"use strict";

const backgroundBox = document.querySelector('.background-box');
const textBox = document.querySelector('.dynamic-text-box');
const imageBox = document.querySelector('.dynamic-image-box');
const main = document.querySelector('main');

function stickyPosition() {
    if (textBox.offsetHeight < imageBox.offsetHeight) {
        textBox.classList.add('sticky-box');
    } else {
        imageBox.classList.add('sticky-box');
    }
}

function createBackgroundBox() {
    const dynamics = document.querySelectorAll('.dynamic');

    let background = document.createElement('div');
    background.classList.add('background-box');

    dynamics.forEach((element) => {
        background.appendChild(element);
    });

    main.insertBefore(background, main.firstElementChild);
}

if (textBox && imageBox) {
    createBackgroundBox();
    stickyPosition();
}
